// types.js

export const InterviewType = Object.freeze({
    CODING: "CODING",
    SYSTEM_DESIGN: "SYSTEM_DESIGN",
    DEEP_DIVE: "DEEP_DIVE",
  });
  
  export const CodingMode = Object.freeze({
    LIVE: "LIVE",
    TIMED: "TIMED",
    DEBUGGING: "DEBUGGING",
  });
  
  export const InterviewStatus = Object.freeze({
    IDLE: "IDLE",
    ACTIVE: "ACTIVE",
    COMPLETED: "COMPLETED",
    FEEDBACK: "FEEDBACK",
  });
  
  export const Persona = Object.freeze({
    NEUTRAL: "Neutral",
    STRICT: "Strict",
    FRIENDLY: "Friendly",
  });
  
  /**
   * @typedef {"typescript"|"javascript"|"python"} SupportedLanguage
   */
  
  /**
   * @typedef {"user"|"ai"|"system"} MessageRole
   */
  
  /**
   * @typedef {Object} Message
   * @property {string} id
   * @property {MessageRole} role
   * @property {string} content
   * @property {number} timestamp
   */
  
  /**
   * @typedef {"Low"|"Medium"|"High"} ClarityLevel
   */
  
  /**
   * @typedef {Object} InterviewMetrics
   * @property {number} correctness
   * @property {ClarityLevel} clarity
   */
  
  /**
   * @typedef {Object} InterviewState
   * @property {string} type
   * @property {string=} mode
   * @property {string=} topic
   * @property {Message[]} messages
   * @property {string=} code
   * @property {SupportedLanguage=} language
   * @property {string=} designNotes
   * @property {number} startTime
   * @property {number} duration
   * @property {string} status
   * @property {InterviewMetrics} metrics
   */
  
  /**
   * @typedef {"Junior"|"Mid-Level"|"Senior"|"Staff"} Seniority
   */
  
  /**
   * @typedef {Object} RadarDatum
   * @property {string} subject
   * @property {number} A
   * @property {number} fullMark
   */
  
  /**
   * @typedef {Object} FeedbackData
   * @property {number} score
   * @property {Seniority} seniority
   * @property {string[]} strengths
   * @property {string[]} weaknesses
   * @property {RadarDatum[]} radarData
   * @property {string} summary
   */
  